// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-hidden {
    display: none;
}
.lr-time-container {
  position: relative;
  margin-top: 32px;
  margin-bottom: 35px;
}
.lr-time-container.lr-open {
  border: solid 1px #e6e6e6;
  padding: 15px;
  margin-top: 17px;
}
.lr-time-btn {
  background: none;
  border: none;
  display: block;
  color: #E81E1E;
  margin-left: auto;
  margin-right: auto;
}
.lr-time-container.lr-open .lr-time-btn {
  color: #6e6e6e;
}
.lr-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7px;
}
.lr-time-input {
  color: #000;
  font-size: 25px;
  text-align: center;
  border: none;
}
.lr-close-btn {
  position: absolute;
  top: 14px;
  right: 15px;
  height: 28px;
  width: 28px;
}
.lr-close-btn .-oneX-icon--close {
  left: 0;
  top: 0;
}
input[type=radio].-oneX-radio+label::before {
  background: none !important;
  margin: 0 !important;
  height: 0 !important;
  width: 0 !important;
  max-height: 0 !important;
  max-width: 0 !important;
  min-height: 0 !important;
  min-width: 0 !important;
}
input[type=radio].-oneX-radio:active+label {
  background: #003A65;
  color: #fff;
  font-weight: bold;
}
input[type=radio].-oneX-radio:checked+label {
  background: #F4F3F3;
  color: #fff;
  font-weight: bold;
}
input[type=radio].-oneX-radio:checked:hover+label {
  color: #fff;
}
.lr-radio-label {
  width: 54px !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  line-height: 52px;
}
.lr-colin {
  font-size: 25px;
  font-weight: normal;
}

@media(min-width: 768px) {
  .lr-time {
      margin-top: 18px;
  }
}

.fallBackTimePicker {
  text-align: center;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/birth-date/birth-date.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,OAAO;EACP,MAAM;AACR;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;MACI,gBAAgB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".error-hidden {\n    display: none;\n}\n.lr-time-container {\n  position: relative;\n  margin-top: 32px;\n  margin-bottom: 35px;\n}\n.lr-time-container.lr-open {\n  border: solid 1px #e6e6e6;\n  padding: 15px;\n  margin-top: 17px;\n}\n.lr-time-btn {\n  background: none;\n  border: none;\n  display: block;\n  color: #E81E1E;\n  margin-left: auto;\n  margin-right: auto;\n}\n.lr-time-container.lr-open .lr-time-btn {\n  color: #6e6e6e;\n}\n.lr-time {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 7px;\n}\n.lr-time-input {\n  color: #000;\n  font-size: 25px;\n  text-align: center;\n  border: none;\n}\n.lr-close-btn {\n  position: absolute;\n  top: 14px;\n  right: 15px;\n  height: 28px;\n  width: 28px;\n}\n.lr-close-btn .-oneX-icon--close {\n  left: 0;\n  top: 0;\n}\ninput[type=radio].-oneX-radio+label::before {\n  background: none !important;\n  margin: 0 !important;\n  height: 0 !important;\n  width: 0 !important;\n  max-height: 0 !important;\n  max-width: 0 !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n}\ninput[type=radio].-oneX-radio:active+label {\n  background: #003A65;\n  color: #fff;\n  font-weight: bold;\n}\ninput[type=radio].-oneX-radio:checked+label {\n  background: #F4F3F3;\n  color: #fff;\n  font-weight: bold;\n}\ninput[type=radio].-oneX-radio:checked:hover+label {\n  color: #fff;\n}\n.lr-radio-label {\n  width: 54px !important;\n  justify-content: center !important;\n  align-items: center !important;\n  padding: 0 !important;\n  line-height: 52px;\n}\n.lr-colin {\n  font-size: 25px;\n  font-weight: normal;\n}\n\n@media(min-width: 768px) {\n  .lr-time {\n      margin-top: 18px;\n  }\n}\n\n.fallBackTimePicker {\n  text-align: center;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
